export default ({
  month: {
    label: 'month',
    key: 'monthly',
    discount: 0,
    months: 1,
    perUserMonthPrice: 20,
    perUserPlan: 'monthly-standard-plan',
  },
  year: {
    label: 'year',
    key: 'annual',
    discount: 0.10,
    months: 12,
    perUserMonthPrice: 18,
    perUserPlan: 'annual-standard-plan',
  },
});
